module.exports = __webpack_public_path__ + "img/hero_portrait_necromancer_male.aff335a4.png";